<template>

  <div class="form-group" :data-code="element.code" v-if="render">
    <label :title="tooltip(element.label)">
      {{ t(element.label) }}
      <icons-render :propIcons="element.icons"/>
    </label>
    <div class="input-group">
      <div class="date-wrapper" @click="_dateIconClick">
        <div class="date-picker-overlay"></div>
        <span class="input-group-addon absolute">
            <i class="icon wb-calendar" aria-hidden="true"></i>
          </span>
        <input
          v-model="dateValue"
          ref="dateElement"
          type="text"
          autocomplete="off"
          readonly="readonly"
          class="form-control input-date"
          v-bind:name="element.name + '_date'"
        />
      </div>
      <div class="time-wrapper">
        <span class="input-group-addon pos-absolute">
          <span class="wb-time"></span>
        </span>
        <input
          v-if="element.readonly"
          v-model="timeValue"
          :readonly="element.readonly"
          class="form-control absolute-icon"
        />
        <input
          v-if="!element.readonly && element.dataType === types.dataType.datetimeinput"
          v-model="timeValue"
          @change="_timeChange"
          @keydown="isNumber($event)"
          class="form-control absolute-icon"
        />
        <select
          v-if="!element.readonly && element.dataType === types.dataType.datetime"
          v-model="timeValue"
          @change="_timeChange"
          class="form-control absolute-icon"
          v-bind:name="element.name + '_time'"
        >
          <option value="00:00">00:00</option>
          <option value="00:15">00:15</option>
          <option value="00:30">00:30</option>
          <option value="00:45">00:45</option>
          <option value="01:00">01:00</option>
          <option value="01:15">01:15</option>
          <option value="01:30">01:30</option>
          <option value="01:45">01:45</option>
          <option value="02:00">02:00</option>
          <option value="02:15">02:15</option>
          <option value="02:30">02:30</option>
          <option value="02:45">02:45</option>
          <option value="03:00">03:00</option>
          <option value="03:15">03:15</option>
          <option value="03:30">03:30</option>
          <option value="03:45">03:45</option>
          <option value="04:00">04:00</option>
          <option value="04:15">04:15</option>
          <option value="04:30">04:30</option>
          <option value="04:45">04:45</option>
          <option value="05:00">05:00</option>
          <option value="05:15">05:15</option>
          <option value="05:30">05:30</option>
          <option value="05:45">05:45</option>
          <option value="06:00">06:00</option>
          <option value="06:15">06:15</option>
          <option value="06:30">06:30</option>
          <option value="06:45">06:45</option>
          <option value="07:00">07:00</option>
          <option value="07:15">07:15</option>
          <option value="07:30">07:30</option>
          <option value="07:45">07:45</option>
          <option value="08:00">08:00</option>
          <option value="08:15">08:15</option>
          <option value="08:30">08:30</option>
          <option value="08:45">08:45</option>
          <option value="09:00">09:00</option>
          <option value="09:15">09:15</option>
          <option value="09:30">09:30</option>
          <option value="09:45">09:45</option>
          <option value="10:00">10:00</option>
          <option value="10:15">10:15</option>
          <option value="10:30">10:30</option>
          <option value="10:45">10:45</option>
          <option value="11:00">11:00</option>
          <option value="11:15">11:15</option>
          <option value="11:30">11:30</option>
          <option value="11:45">11:45</option>
          <option value="12:00">12:00</option>
          <option value="12:15">12:15</option>
          <option value="12:30">12:30</option>
          <option value="12:45">12:45</option>
          <option value="13:00">13:00</option>
          <option value="13:15">13:15</option>
          <option value="13:30">13:30</option>
          <option value="13:45">13:45</option>
          <option value="14:00">14:00</option>
          <option value="14:15">14:15</option>
          <option value="14:30">14:30</option>
          <option value="14:45">14:45</option>
          <option value="15:00">15:00</option>
          <option value="15:15">15:15</option>
          <option value="15:30">15:30</option>
          <option value="15:45">15:45</option>
          <option value="16:00">16:00</option>
          <option value="16:15">16:15</option>
          <option value="16:30">16:30</option>
          <option value="16:45">16:45</option>
          <option value="17:00">17:00</option>
          <option value="17:15">17:15</option>
          <option value="17:30">17:30</option>
          <option value="17:45">17:45</option>
          <option value="18:00">18:00</option>
          <option value="18:15">18:15</option>
          <option value="18:30">18:30</option>
          <option value="18:45">18:45</option>
          <option value="19:00">19:00</option>
          <option value="19:15">19:15</option>
          <option value="19:30">19:30</option>
          <option value="19:45">19:45</option>
          <option value="20:00">20:00</option>
          <option value="20:15">20:15</option>
          <option value="20:30">20:30</option>
          <option value="20:45">20:45</option>
          <option value="21:00">21:00</option>
          <option value="21:15">21:15</option>
          <option value="21:30">21:30</option>
          <option value="21:45">21:45</option>
          <option value="22:00">22:00</option>
          <option value="22:15">22:15</option>
          <option value="22:30">22:30</option>
          <option value="22:45">22:45</option>
          <option value="23:00">23:00</option>
          <option value="23:15">23:15</option>
          <option value="23:30">23:30</option>
          <option value="23:45">23:45</option>
        </select>
      </div>

    </div>
    <div class="clearfix"></div>
    <div v-if="this.buttonsDef.length" class="col-sm-4 pl-0 form-element-button-wrapper">
      <form-action-button
        :def="def"
        :buttonsDef="buttonsDef"
        :updateDataRequest="updateDataRequest"
        :formDataChanged="formDataChanged"/>
    </div>
  </div>

</template>

<script>
import DatetimeParser           from '../../../model/parser/datetime-parser'
import CalendarTranslator       from '../../../model/translator/CalendarTranslator'
import IconsRender              from '../../templates/widgets/icons-render'
import FormElementTypes         from '../../../model/FormElementTypes'
import FormElementButtonsHelper from '../../../model/helper/forms/form-element-buttons-helper'
import FormActionButton         from '../../widgets/forms/form-action-button'
import DictionaryLoader         from '@/model/loader/dictionary-loader'

export default {
  name:       'date-time-picker',
  components: {
    FormActionButton,
    IconsRender
  },
  props:      {
    def:               {
      type:    Object,
      default: () => {
        return {}
      }
    },
    updateDataRequest: {
      type:    Function,
      default: null
    },
    formDataChanged:   {
      type:    Function,
      default: null
    },
    element:           {
      required: true,
      type:     Object,
      default:  () => {
        return {
          name:     null,
          type:     null,
          dataType: null,
          label:    null
        }
      }
    }
  },

  data () {
    return {
      dateValue:          '',
      timeValue:          '',
      lastValidValue:     '',
      stateDateTimeValue: DatetimeParser.createDate(),
      types:              FormElementTypes,
      buttonsDef:         [],
      render:             true
    }
  },

  created () {
    let tr = (key) => {
      return this.$translate.text(key)
    }

    let translator = new CalendarTranslator(this.$translate)

    $.fn.datepicker.dates['own'] =
      {
        days:        translator.getDays(),
        daysShort:   translator.getShortDays(),
        daysMin:     translator.getMinDays(),
        months:      translator.getMonths(),
        monthsShort: translator.getShortMonths(),
        today:       tr('date_today'),
        clear:       tr('date_clear'),
        titleFormat: 'MM yyyy'
      }
  },

  mounted () {
    this.buttonsDef = FormElementButtonsHelper.getButtonsDef(this.element)

    if (this.element.readonly) {
      return
    }

    let dateElement = $(this.$refs.dateElement)

    dateElement
      .datepicker({
        format:         'dd.mm.yyyy',
        todayHighlight: true,
        orientation:    'left auto',
        language:       'own',
        weekStart:      1,
        autoClose:      true,
        todayBtn:       true,
        clearBtn:       true
      })
      .on('changeDate', (event) => {
        if (!event.date) {
          this.stateDateTimeValue = null
          this.timeValue          = null
          this.lastValidValue     = null
          this.dateValue          = null

          this._changeValue()

          return
        }

        if (event.date && !this.stateDateTimeValue) {
          this.stateDateTimeValue = DatetimeParser.createDate()
        }

        let hours = this.stateDateTimeValue.getHours(),
            mins  = this.stateDateTimeValue.getMinutes()

        this.stateDateTimeValue = event.date
        this.stateDateTimeValue.setHours(hours, mins)

        this.dateValue = DatetimeParser.parseLocaleDate(this.stateDateTimeValue.toLocaleString())

        // nastaveni vychoziho casu pokud neni nastaven
        if (!this.timeValue) {
          let hour = '12',
              min  = '00',
              time = hour + ':' + min

          this.timeValue = time
          this.stateDateTimeValue.setHours(parseInt(hour), parseInt(min))
        }

        this._changeValue()

        dateElement.datepicker('hide')
      })
  },

  methods: {

    isNumber: function (evt) {
      let keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ':', 'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight']

      if (['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(evt.key)) {
        return
      }

      if (!keysAllowed.includes(evt.key)) {
        evt.preventDefault()
        return
      }

      return true
    },

    _timeChange (arg) {
      let value      = $(arg.target).val(),
          valueSplit = value.split(':'),
          hours      = valueSplit[0],
          mins       = valueSplit[1],
          regex      = new RegExp(/^([01]\d|2[0-3]):?([0-5]\d)$/)

      if (regex.test(value) !== true) {
        this.timeValue = this.lastValidValue
        return
      }

      this.stateDateTimeValue.setHours(hours)
      this.stateDateTimeValue.setMinutes(mins)

      this.timeValue      = value
      this.lastValidValue = this.timeValue

      this._changeValue()
    },

    /**
     *
     * @private
     */
    _changeValue () {
      this.$emit('changeValue', { element: this.element, value: this._prepareValue() })
      this.$emit('blur', { element: this.element, value: this._prepareValue() })
    },

    /**
     *
     * @return {string|null}
     * @private
     */
    _prepareValue () {
      if (!this.stateDateTimeValue) {
        return null
      }

      return DatetimeParser.dateObjectToISO(this.stateDateTimeValue)
    },

    /**
     *
     * @param value
     */
    updateValue (value) {
      value = value.value

      if (!value || value === ' ') {
        this.dateValue = null
        this.timeValue = null
        return
      }

      let date      = null,
          splitDate = null,
          day       = null,
          month     = null,
          year      = null,
          time      = null,
          splitTime = null,
          hours     = null,
          mins      = null

      if (value.indexOf('T') > 0) {
        date      = DatetimeParser.parseDate(value)
        splitDate = date.split('.')
        day       = splitDate[0]
        month     = splitDate[1]
        year      = splitDate[2]
        time      = DatetimeParser.parseTime(value)
        splitTime = time.split(':')
        hours     = splitTime[0]
        mins      = splitTime[1]
      }
      else {
        date      = DatetimeParser.parseUnifiDate(value)
        splitDate = date.split('.')
        day       = splitDate[0]
        month     = splitDate[1]
        year      = splitDate[2]
        time      = DatetimeParser.parseUnifiTime(value)
        splitTime = time.split(':')
        hours     = splitTime[0]
        mins      = splitTime[1]
      }

      this.dateValue      = date
      this.timeValue      = time
      this.lastValidValue = time

      this.stateDateTimeValue = DatetimeParser.createDate(year, month, day, hours, mins, 0)

      // @TODO: datepicker hack - https://github.com/uxsolutions/bootstrap-datepicker/issues/1775
      $.fn.datepicker.defaults.format = 'dd.mm.yyyy'

      $(this.$refs.dateElement).datepicker('update', this.stateDateTimeValue)
    },

    /**
     *
     * @param values
     * @param fieldName
     */
    updateHighlighters (values, fieldName) {
      this.element.icons.forEach((icon) => {
        if (icon.def.ColumnName === fieldName) {
          icon.value = JSON.parse(values.value)
        }
      })
    },

    /**
     *
     * @private
     */
    _dateIconClick () {
      if (this.element.readonly) {
        return
      }

      $(this.$refs.dateElement).datepicker('show')
    },

    setRender (render) {
      this.render = render
    },

    tooltip (key) {
      return DictionaryLoader.tooltip(key, this.$user.languageCode)
    }

  }

}
</script>

<style>
.datepicker-dropdown {
  z-index: 99999 !important;
}
</style>
